var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGlobeBlue(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.9001 12.0016C21.9001 17.4692 17.4677 21.9016 12.0001 21.9016M21.9001 12.0016C21.9001 6.53394 17.4677 2.10156 12.0001 2.10156M21.9001 12.0016H2.1001M12.0001 21.9016C6.53248 21.9016 2.1001 17.4692 2.1001 12.0016M12.0001 21.9016C14.154 21.9016 15.9001 17.4692 15.9001 12.0016C15.9001 6.53394 14.154 2.10156 12.0001 2.10156M12.0001 21.9016C9.84619 21.9016 8.1001 17.4692 8.1001 12.0016C8.1001 6.53394 9.84619 2.10156 12.0001 2.10156M2.1001 12.0016C2.1001 6.53394 6.53248 2.10156 12.0001 2.10156",
    stroke: "#007BFF",
    strokeWidth: 1.5,
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGlobeBlue);
export default __webpack_public_path__ + "static/media/globe-blue.5e60b0351fba44bdafbc6b4317b7ae57.svg";
export { ForwardRef as ReactComponent };